// Helper formatter using standard Internationalization API
const formatCurrency = (val = 0) =>
	new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(val);

function initEarningsCalculator() {
	const app = document.querySelector('[data-ec]');
	if (!app) return;
	const id = app.getAttribute('data-ec');
	const form = app.querySelector('[data-ec-form]');
	if (!id || !form) return;
	const specialtyId = id + '-specialty',
		frequencyId = id + '-frequency',
		volumeId = id + '-volume',
		communityId = id + '-community',
		referralId = id + '-referral';

	const inputs = {
		specialty: form.querySelector('[name="' + specialtyId + '"]'),
		frequency: form.querySelector('[name="' + frequencyId + '"]'),
		volume: form.querySelector('[name="' + volumeId + '"]'),
		community: form.querySelector('[name="' + communityId + '"]'),
		referral: form.querySelector('[name="' + referralId + '"]'),
	};

	const outputs = {
		estimate: app.querySelector('[data-estimate]'),
		estimateLow: app.querySelector('[data-estimate-low]'),
		estimateHigh: app.querySelector('[data-estimate-high]'),
		estimatePlaceholder: app.querySelector('[data-estimate-placeholder]'),
		benchmarkQuote: app.querySelector('[data-benchmark-quote]'),
		benchmarkValue: app.querySelector('[data-benchmark-value]'),
		benchmarkSpecialty: app.querySelector('[data-benchmark-specialty]'),
	};

	const defaultCommunityBonus = +inputs.specialty.getAttribute('data-default-community-bonus') || 0;
	const defaultReferralBonus = +inputs.specialty.getAttribute('data-default-referral-bonus') || 0;

	function getVals() {
		let vals = {};
		if (inputs.specialty.value === '') return vals;
		const selectedSpecialty = inputs.specialty?.selectedOptions[0];
		const selectedFrequency = inputs.frequency?.selectedOptions[0];
		const selectedVolume = inputs.volume?.selectedOptions[0];
		const checkedReferral = form.querySelector('[name="' + referralId + '"]:checked');
		const checkedCommunity = form.querySelector('[name="' + communityId + '"]:checked');
		const specialtyData = selectedSpecialty?.dataset;
		const frequencyData = selectedFrequency?.dataset;
		const volumeData = selectedVolume?.dataset;

		vals.specialty = selectedSpecialty?.text;
		vals.specialtySlug = selectedSpecialty?.value;
		vals.specialtyBenchmark = +specialtyData?.benchmark || 0;
		vals.specialtyPerSurvey = +specialtyData?.perSurvey || 0;
		vals.specialtyMaxSurveys = +specialtyData?.maxSurveys || 0;
		vals.referralBonus = +specialtyData?.referralBonus || defaultReferralBonus;
		vals.communityBonus = +specialtyData?.communityBonus || defaultCommunityBonus;
		vals.frequency = selectedFrequency?.value;
		vals.frequencyMultiplier = +frequencyData?.multiplier || false;
		vals.volume = selectedVolume?.value;
		vals.volumeMultiplierHigh = +volumeData?.multiplierHigh || false;
		vals.volumeMultiplierLow = +volumeData?.multiplierLow || false;
		vals.referral = checkedReferral?.value?.toLowerCase() === "true";
		vals.community = checkedCommunity?.value?.toLowerCase() === "true";
		return vals;
	}

	function updateFields() {
		const vals = getVals();
		console.log(vals);
		if (!vals.specialty) {
			if (outputs.estimate) outputs.estimate.setAttribute('hidden', 'true');
			if (outputs.estimatePlaceholder) outputs.estimatePlaceholder.removeAttribute('hidden');
			if (outputs.benchmarkQuote) outputs.benchmarkQuote.setAttribute('hidden', 'true');
			return;
		}

		// if (!vals.length) return;
		// calculate upper and lower ranges
		let estimateLow = Math.min(vals.frequencyMultiplier * vals.volumeMultiplierLow, .8 * vals.specialtyMaxSurveys) * vals.specialtyPerSurvey;
		let estimateHigh = Math.min(vals.frequencyMultiplier * vals.volumeMultiplierHigh, vals.specialtyMaxSurveys) * vals.specialtyPerSurvey;

		if (vals.referral) {
			estimateLow += vals.referralBonus;
			estimateHigh += vals.referralBonus;
		}
		if (vals.community) {
			estimateLow += vals.communityBonus;
			estimateHigh += vals.communityBonus;
		}
		console.log(estimateLow, estimateHigh);

		// update estimate and estimate placeholder with range values
		if (estimateHigh && estimateLow) {
			if (outputs.estimateLow) outputs.estimateLow.textContent = formatCurrency(Math.round(estimateLow / 10) * 10);
			if (outputs.estimateHigh) outputs.estimateHigh.textContent = formatCurrency(Math.round(estimateHigh / 10) * 10);
			if (outputs.estimate) outputs.estimate.removeAttribute('hidden');
			if (outputs.estimatePlaceholder) outputs.estimatePlaceholder.setAttribute('hidden', 'true');
		}

		// update benchmark quote
		if (vals.specialtyBenchmark) {
			if (outputs.benchmarkValue) outputs.benchmarkValue.textContent = formatCurrency(vals.specialtyBenchmark);
			if (outputs.benchmarkSpecialty) outputs.benchmarkSpecialty.textContent = vals.specialty;
			if (outputs.benchmarkSpecialty) outputs.benchmarkQuote.removeAttribute('hidden');
		}
	}

	// Event listener with initial calculation
	form?.addEventListener('change', updateFields);
	form?.addEventListener('input', updateFields);
	updateFields();
}

document.addEventListener('DOMContentLoaded', initEarningsCalculator);
